/**
 * Prevents a function from being called too frequently.
 * 
 * @param func 
 * @param intervalMs interval in milliseconds to throttle the function calls
 * @returns 
 */
export function throttle<T extends (...args: any[]) => void>(func: T, intervalMs: number): T {
    let inThrottle = false

    return function(this: any, ...args: any[]) {
        if (!inThrottle) {
            func.apply(this, args)
            inThrottle = true
            setTimeout(() => inThrottle = false, intervalMs)
        }
    } as T
}
